// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import axios from 'axios'
import VeeValidate, {Validator} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'
// [ext] store inject
import StoreProvider from './common/provider/store.provider.js'
import VueI18n from 'vue-i18n'
import HttpPlugIn from './common/provider/http.js'
Vue.use(VueI18n)
let defaultLang = process.env.PUBLISH_LANG || 'zh'
console.log(process.env.PUBLISH_LANG)
let lang = sessionStorage.getItem('lang')
if (!lang) {
  lang = defaultLang
}
const i18n = new VueI18n({
  locale: lang,
  messages: {
    'zh': require('./common/lang/cn'),
    'en': require('./common/lang/en')
  }
})
Vue.config.productionTip = false

Vue.prototype.$http = HttpPlugIn
Vue.config.productionTip = false

Validator.addLocale(zh)

const config = {
  locale: 'zh_CN'
}

Vue.use(VeeValidate, config)

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  i18n,
  store: StoreProvider,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js